import { ResellerAgreementStatus } from '../../types/flyout'

export const mappingResaleForAdmin = {
  'Reseller name': 'resellerName',
  'Labra reseller agreement ID': 'id',
  'Product title': 'productName',
  'Created date': 'createdAt',
  'Authorization ID': 'awsAgreementId',
  Status: 'status',
  '': 'actions',
}

export const mappingResaleForLabraUI = {
  Reseller: 'resellerName',
  'Authorization name': 'authorizationName',
  Product: 'productName',
  'End date': 'expiredAt',
  Status: 'status',
  '': 'actions',
}

export const mappingResaleForLabraUIMPPO = {
  Buyer: 'companyName',
  Reseller: 'resellerName',
  'Authorization name': 'authorizationName',
  Product: 'productName',
  'End date': 'expiredAt',
  Status: 'status',
  '': 'actions',
}

export const statusMappingForLabraV2UI: Record<
  string,
  ResellerAgreementStatus
> = {
  'In Progress': ResellerAgreementStatus.IN_PROGRESS,
  Active: ResellerAgreementStatus.ACTIVE,
  Expired: ResellerAgreementStatus.EXPIRED,
  Completed: ResellerAgreementStatus.COMPLETED,
  'Deactivation in progress': ResellerAgreementStatus.DEACATIVATION_IN_PROGRESS,
  Restricted: ResellerAgreementStatus.RESTRICTED,
}
